import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../globalModule/assets/icons/copy.png'


const _withScopeId = n => (_pushScopeId("data-v-1eeca1e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-window"
}
const _hoisted_2 = { class: "command-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "copy-img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" If you have trouble running this command, it is likely that you ros2 is not installed properly. To install ros, follow the instructions "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.ros.org/en/humble/Installation/Ubuntu-Install-Debians.html",
    target: "_blank"
  }, "here"),
  /*#__PURE__*/_createTextVNode(". Make sure to do the desktop install to ensure all tools are installed. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.description && _ctx.commandText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(_ctx.description), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", { ref: "c" }, _toDisplayString(_ctx.commandText), 513),
            _createElementVNode("button", {
              class: "icon-button copy-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyText()))
            }, _hoisted_4)
          ]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.description && _ctx.commandText)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "dialog-bg center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exit()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}